export const CONFIGURATION = {
  binance: {
    key: 'BINANCE_API_KEY',
    secret: 'BINANCE_API_SECRET',
    exchangeType: 'futures' // spot is not supported yet
  },
  okx: {
    key: 'OKX_API_KEY',
    secret: 'OKX_API_SECRET',
    alp:'YOUR WORD',
    exchangeType: 'futures' // spot is not supported yet
  },
  profile: {
    name: 'John Doe'
  }
};
